<template>
  <Dialog
      :title="title"
      :show="showDialog"
      @onCancel="onCancel"
      @onConfirm="onConfirm"
      class="jy-common-message-box"
      :width="width"
  >
    <div class="jy-common-message-title">
      {{ formTitle }}
    </div>
    <div class="jy-common-message-elInput">
      <el-date-picker
          v-if="inputType === 'datetime'"
          v-model="content"
          value-format="YYYY-MM-DD HH:mm:ss"
          type="datetime"
      />
      <el-select
          v-else-if="inputType === 'ajax'"
          v-model="content"
          clearable
          @visible-change="visibleChange($event, select.parms)"
          style="width: 100%"
      >
        <el-option
            :label="value[select.label]"
            :value="value[select.value]"
            v-for="(value, key) in selectOpt"
            :key="key"
        />
      </el-select>
      <el-input
          v-else
          v-model.trim="content"
          :rows="rows"
          :type="inputType"
          placeholder="请输入"
          @keyup.enter.native="onConfirm"
      />
    </div>
  </Dialog>
</template>

<script>
import { Message as ElMessage } from 'element-ui';
import utils from "@/assets/js/tool";

export default {
  name: 'MessageBox',
  props: {
    timesVal: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '系统提示'
    },
    formTitle: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    inputType: {
      type: String,
      default: 'input'
    },
    rows: {
      type: Number,
      default: 5
    },
    width: {
      type: String,
      default: "500"
    },
    select: {
      type: Object,
      default: () => ({
        parms: null,
        label: '',
        value: '',
        options: []
      })
    }
  },
  data() {
    return {
      showDialog: this.show,
      content: this.timesVal || '',
      selectOpt: []
    };
  },
  watch: {
    show(newValue) {
      this.showDialog = newValue;
    },
    timesVal(newValue) {
      this.content = newValue;
    }
  },
  methods: {
    onCancel() {
      this.showDialog = false;
      this.content = '';
      this.$emit('onMessageBoxCancel');
    },
    onConfirm() {
      if (!this.content && this.formTitle !== '审核备注') {
        ElMessage.error('不能为空');
        return;
      }
      this.$emit('onMessageBoxConfirm', this.content);
      this.content = "";
    },
    visibleChange(val, select) {
      if (val) {
        utils.getSelectData(select.parms, select.type, select.more).then(res => {
          this.selectOpt = res.arr;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
